import React from 'react';
import ThemeProvider from 'providers/ThemeProvider';
import "@fontsource/bodoni-moda" // Defaults to weight 400.

export const onServiceWorkerUpdateReady = () => window.location.reload(true);

export const wrapRootElement = ({ element }) => <ThemeProvider>{element}</ThemeProvider>;
